import { Column, Entity, PrimaryColumn } from "typeorm"

@Entity()
export class CachedLookupLocation {
  
  @PrimaryColumn()
	id!: string
  
  @Column({ type: 'float' })
  lat!: number

  @Column({ type: 'float' })
  lon!: number

  @Column({ type: 'float' })
  accuracy!: number

  @Column('datetime')
	last_check!: Date
}